// extracted by mini-css-extract-plugin
export default {"tabs":"TabNav_tabs__8QDtI"};